import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { throwError } from "rxjs";
import { ApiService } from "../api.service";

const PATH = "auth";

@Injectable({
  providedIn: "root",
})
export class AuthHandlerService {
  constructor(private apiService: ApiService) {}

  authPost(params: any, options?: any) {
    return this.apiService.post(PATH, params, options);
  }

  authGet(authToken: string) {
    return this.apiService.get(PATH, {
      headers: new HttpHeaders({ Authorization: authToken }),
    });
  }

  passwordRequest(email: string) {
    return this.apiService.post(`${PATH}/password/request`, {
      username: email,
      v3: true,
    });
  }

  passwordResetGet(resetToken: string) {
    return this.apiService.get(`${PATH}/password/reset/${resetToken}`);
  }

  passwordResetPut(password: string, userID: string, resetToken: string) {
    return this.apiService.put(`${PATH}/password/reset`, {
      password,
      user_id: userID,
      reset_token: resetToken,
    });
  }

  activateGet(activateToken: string) {
    return this.apiService.get(`${PATH}/activate/${activateToken}`);
  }

  activatePut(password: string, userID: string, activateToken: string) {
    return this.apiService.put(`${PATH}/activate`, {
      password,
      user_id: userID,
      activation_token: activateToken,
    });
  }
}
